import client from '@/api/client.js';
import store from "@/store";
export default {
    methods: {
        async getMyAccount() {
            var meta = { clientApiMethod: 'getMyAccount' }
            var response = await client().get(store.state.apiRouteRoot + "User/MyAccount/", { meta: meta })
            return response?.data;
        },
        async updateMyAccount(dto) {
            var meta = { clientApiMethod: 'updateMyAccount' }
            var response = await client().patch(store.state.apiRouteRoot + "User/MyAccount/", dto, { meta: meta })
            return response?.data;
        },
        async getUserAccountById(userId) {
            var meta = { clientApiMethod: 'getUserAccountById', input: { userId: userId } }
            var response = await client().get(store.state.apiRouteRoot + "UserController/getAccount/" + userId, { meta: meta })
            return response?.data;
        },
        async resetpasswordmail(email) {
            var meta = { clientApiMethod: 'resetpasswordmail', input: { email: email } }
            var emailstring = encodeURI(email)
            var response = await client().post(store.state.apiRouteRoot + "password/sendresetpasswordmail?emailaddress=" + emailstring, null, { meta: meta })
            return response?.data;
        },
        async resetpassword(dto) {
            var meta = { clientApiMethod: 'resetpassword', input: { dto: dto } }
            var response = await client().post(store.state.apiRouteRoot + "password/resetpassword", dto, { meta: meta })
            return response?.data;
        },
        async setPasswordToDefault(email) {
            var meta = { clientApiMethod: 'setPasswordToDefault', input: { email: email } }
            var response = await client().post(store.state.apiRouteRoot + "password/RecoverPassword?Email=" + email, null, { meta: meta })
            return response?.data;
        },
    }
}